<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1A1lg2V/media/FC-9781398490383.jpg?1685790453751" alt="This image is the cover for the book Dr Nathaniel Goodrich - The Plight of Divorcement"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dr Nathaniel Goodrich - The Plight of Divorcement
      </h1>
      <p class="bookDescription body article font2">
        <p>Struggling to understand the challenges and exert positive change in his marriage, Dr Nathaniel Goodrich, a principal investigator of haematology, and the first in line to inherit a conglomerate of pharmaceutical-related companies, has something in mind. And then in the scrub room, he catches the radiating sparks in Dr Kristopher McCall’s mesmerising eyes. That is when Nathaniel recognises the appointed time is intimate. No longer determined to keep his inclination of intrigue to himself, Nathaniel faces a life-changing decision. What Nathaniel does not intend is to lose Annabeth, his beloved wife and disadvantage his four dear children. Nathaniel knows that if he were to pursue his secret self-interest, his parents would seek to disinherit him. But is it too late – a beautiful mess? Is Nathaniel conquered by the glow of the magic hour? If only Nathaniel can find out why Annabeth cannot be pleased before it’s too late. Only then can he solve his marriage predicament and hide his head during the appointed hour.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Consonants Vowels
      </h2>
      
      <p class="authorDescription body article">An experienced information professional, Consonants has depicted her career’s most thought-provoking subject requests and has creatively answered them in her debut novel, Dr Nathaniel Goodrich – The Plight of Divorcement. Consonants has also appeared in and choreographed runway shows, learning about executing graceful ideas. Consonants lives in Australia where she enjoys attending cultural events, keeping fit, and gaming.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?113d075d